import Model from '@/models/Model'

export default class SlSaleQuotation extends Model {
    resource() {
        return 'sl_sale_quotation'
    }
}